import { useProjectComments } from "@/hooks/use-project-comments";
import type { UserLookup } from "@/hooks/use-users";
import { SrIcon } from "@/components/ui/SrIcon";
import { CollapsibleCard } from "@/components/shared/CollapsibleCard";
import { ProjectUpdatesPanel } from "./ProjectUpdatesPanel";
import { OpenInChatLink } from "./OpenInChatLink";

/**
 * «Prosjektoppdateringer»-kortet på prosjektsiden (tidligere `ChatTab`, døpt
 * om i VIB-2179 for ikke å forveksles med person-til-person-chatten).
 * Selve panelet bor i `ProjectUpdatesPanel` og deles med
 * `ProjectUpdatesDialog`.
 */
export default function ProjectUpdatesTab({ projectId, users }: { projectId: string; users: UserLookup[] }) {
  const { data: comments } = useProjectComments(projectId);
  const commentCount = (comments ?? []).length;

  return (
    <CollapsibleCard
      title="Prosjektoppdateringer"
      icon={<SrIcon name="message-square" className="w-5 h-5 text-primary" />}
      count={commentCount > 0 ? commentCount : undefined}
      actions={<OpenInChatLink projectId={projectId} />}
      className="flex flex-col max-h-[500px]"
      contentClassName="border-t flex-1 flex flex-col min-h-0"
    >
      <ProjectUpdatesPanel projectId={projectId} users={users} />
    </CollapsibleCard>
  );
}
